import LoginPage from './LoginPage'

export const LoginPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: '/login',
      component: LoginPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/login/LoginPageConfig.js